// extracted by mini-css-extract-plugin
export default {"container":"NotFoundPage_container__JbBAr","textError":"NotFoundPage_textError__-SpYz"};